export default __webpack_public_path__ + "static/media/daycare.50f18e08.svg";